import React from "react";
import { graphql } from "gatsby";
import ReactPlayer from "react-player";

export const fragment = graphql`
    fragment VideoSection on SanityVideo {
        _key
        _type
        videoTitle
        videoUrl
    }
`;

const Video = (props) => {
    return (
        <>
            <div key={props.key} className="container mx-auto mb-12 xl:w-5/6">
                <div className="video">
                    <ReactPlayer url={props.videoUrl} controls="true" />
                </div>
            </div>
        </>
    );
};
export default Video;
